jQuery(document).ready(function ($) {
    $(document).on('submit', '#resource-download-form', function (e) {
        document.cookie = "resourceNonce=1; path=/; max-age=" + (60 * 60 * 24 * 7);
    });

    $(document).on('facetwp-loaded', function () {
        let searchVal = FWP.facets['search']; // 'search' = your facet name

        let searchHeader = $('.wbcsd-search-header h1.search-title');

        if (searchVal && searchVal.length > 0) {
            let titleHTML = 'You searched for: <em>' + searchVal + '</em>';
            searchHeader.html(titleHTML);
        } else {
            searchHeader.text(searchHeader.data('base-title'));
        }
    });

    $(document).on('facetwp-loaded', function () {
        if (FWP.loaded) { // Run only after the initial page load
            $('html, body').animate({
                scrollTop: $('.facetwp-template').offset().top - 250 // Scroll to the top of the element with class "facetp-template"
            }, 500);
        }
    });

    // Convert FacetWP filter to dropdown
    $('.refinement-container-mobile').each(function () {
        const facetFilter = $('.facetwp-facet.facetwp-type-radio');
        const container = document.querySelector('.facetwp-type-radio');

        const updateLabel = () => {
            const checked = container.querySelector('.facetwp-radio.checked');
            if (checked) {
                const displayValue = checked.querySelector('.facetwp-display-value');
                const label = displayValue ? displayValue.innerText.trim() : checked.innerText.trim();
                container.setAttribute('data-selected-label', label);
            }
        };

        facetFilter.on('click', function (e) {
            e.stopPropagation();
            $(this).toggleClass('dropdown-open');
        });

        facetFilter.on('click', '.facetwp-radio', function (e) {
            e.stopPropagation();
            $(this).siblings().removeClass('checked');
            $(this).addClass('checked');
            updateLabel();
            facetFilter.removeClass('dropdown-open');

            if (typeof FWP !== 'undefined') {
                FWP.refresh();
            }
        });

        $(document).on('click', function () {
            facetFilter.removeClass('dropdown-open');
        });

        updateLabel();
    });

    // Search on mobile
    $(document).on('click touchstart', '.nav-search', function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.addClass('search-open');

        if ($this.hasClass('search-open')) {
            setTimeout(() => {
                $('#search-input.form-input').trigger('focus');
            }, 100);
        }
    });

    $(document).on('click touchstart', function (e) {
        if (!$(e.target).closest('.nav-search, #search-input, .searchwp-live-search-results-showing').length) {
            $('.nav-search').removeClass('search-open');
        }
    });

});